ModelCache = require 'db/model-cache'
React = require 'react'
xtend = require 'xtend'

module.exports = (ComposedComponent) -> class extends React.Component
  constructor: (props) ->
    super
    @listeners = []

  listenTo: (events, callback) ->
    ModelCache.on events, callback
    @listeners.push
      events: events
      callback: callback

  componentWillUnmount: ->
    @listeners.forEach(({ events, callback }) -> ModelCache.off events, callback)

  render: ->
    newProps = xtend @props, listenTo: @listenTo.bind(@)

    React.createElement ComposedComponent, newProps




// WEBPACK FOOTER //
// ./app/scripts/views/internal/model-cache-listener.coffee